module.exports = __webpack_public_path__ + "static/media/search-img.24b9bd3f.svg";